import type {ReactElement} from 'react';
import styles from '../ai-prompt-box-attachment-preview/ai-prompt-box-attachment-preview.module.scss';
import {AiPromptBoxSize} from '@Components/ai-prompt-box/ai-prompt-box.types';
import {Icon} from '@Components/icon-v2';
import {IconShape, IconSize} from '@Components/icon-v2/icon.types';
import {CircularProgressLoader, LOADER_COLOR, LOADER_SIZE} from '@Components/circular-progress-loader';
import type {AiPromptBoxLoadingAttachmentPreviewProps} from './ai-prompt-box-loading-attachment-preview.types';

export function AiPromptBoxLoadingAttachmentPreview({id, size, onRemove}: AiPromptBoxLoadingAttachmentPreviewProps): ReactElement {
  const sizeDimensionMap = {
    [AiPromptBoxSize.SMALL]: 48,
    [AiPromptBoxSize.MEDIUM]: 56,
    [AiPromptBoxSize.SINGLE_LINE]: 48,
    [AiPromptBoxSize.SMALL_EXTENDED]: 48,
  };

  const sizeClassMap = {
    [AiPromptBoxSize.SMALL]: styles.small,
    [AiPromptBoxSize.MEDIUM]: styles.medium,
    [AiPromptBoxSize.SINGLE_LINE]: styles.small,
    [AiPromptBoxSize.SMALL_EXTENDED]: styles.small,
  };

  const dimension = sizeDimensionMap[size];

  return (
    <div className={`${styles.attachment} ${sizeClassMap[size]}`}>
      <div className={`${styles.attachmentItem} ${styles.placeholder} spacing-m-b-2`} style={{width: dimension, height: dimension}} />
      <div className={styles.uploadingOverlay}>
        <CircularProgressLoader color={LOADER_COLOR.DARK} size={LOADER_SIZE.XXSMALL} classes="_unmargin" />
      </div>
      <Icon
        className={styles.removeAttachmentButton}
        icon={'icon-close'}
        size={IconSize.SIZE_ICON_8}
        shape={IconShape.CIRCLE}
        ariaLabel={window.i18next.t('pmwjs_remove')}
        onClick={() => {
          onRemove(id);
        }}
      />
    </div>
  );
}
